import { lazy } from 'react';
import { NoContentPage } from '../components/shared';

const AsyncLanding = lazy(() => import('../containers/shared/landing'));

const AsyncAttendance = lazy(() => import('../containers/admin/SchoolAttendance'));
const AsyncReport = lazy(() => import('../containers/admin/SubjectReport'));
const AsyncProgression = lazy(() => import('../containers/admin/SchoolProgression'));
const AsyncTest = lazy(() => import('../containers/admin/SchoolTest'));
const AsyncNSCSubjects = lazy(() => import('../containers/admin/NSCSubject'));
const AsyncNSCProgression = lazy(() => import('../containers/admin/NSCProgression'));
const AsyncSchoolEnrolment = lazy(() => import('../containers/admin/SchoolEnrolment'));
const AsyncSchoolPromotion = lazy(() => import('../containers/admin/SchoolPromotion'));
const AsyncSchoolEducator = lazy(() => import('../containers/admin/SchoolEducator'));
//const AsyncNSCProgression = lazy(() => import('../containers/admin/NSCProgression'));

const AsyncDataTools = lazy(() => import('../containers/admin/dataTools'));
const AsyncDataToolsSection = lazy(() => import('../containers/admin/dataTools/DataToolsSection'));

const AsyncPeople = lazy(() => import('../containers/shared/peopleProfiles'));
const AsyncPeopleDetails = lazy(() => import('../containers/shared/peopleProfiles/forms/PersonDetails'));

const AsyncAdminTeamMembers = lazy(() => import('../containers/admin/teamMembers'));
const AsyncAdminTeamMembersCreate = lazy(() => import('../containers/admin/teamMembers/forms/CreateForm'));

const AsyncDeclarations = lazy(() => import('../containers/admin/declarations/AllDeclarations'));
const AsyncDeclarationDetails = lazy(() => import('../containers/admin/declarations/declaration'));

const AsyncAdminTemplates = lazy(() => import('../containers/admin/templates/AllAdminTemplates'));
const AsyncAdminTemplateDetails = lazy(() => import('../containers/admin/templates/template'));

const AsyncServiceProviders = lazy(() => import('../containers/admin/ServiceProvider'));
const AsyncServiceProvidersCreate = lazy(() => import('../containers/admin/ServiceProvider/forms/CreateForm'));

const AsyncServiceProviderTeamMembers = lazy(() => import('../containers/admin/ServiceProviderTeamMembers'));
const AsyncServiceProviderTeamMembersCreate = lazy(() =>
  import('../containers/admin/ServiceProviderTeamMembers/forms/CreateForm')
);

const AsyncFunders = lazy(() => import('../containers/admin/Funders'));
const AsyncFundersCreate = lazy(() => import('../containers/admin/Funders/forms/CreateForm'));

const AsyncFunderTeamMembers = lazy(() => import('../containers/admin/FunderTeamMembers'));
const AsyncFunderTeamMembersCreate = lazy(() => import('../containers/admin/FunderTeamMembers/forms/CreateForm'));

const AsyncProgrammes = lazy(() => import('../containers/admin/Programme'));
const AsyncProgrammesCreate = lazy(() => import('../containers/admin/Programme/forms/Details'));

const AsyncInstitutions = lazy(() => import('../containers/admin/Institutions/AllInstitutions'));
const AsyncInstitutionsCreate = lazy(() => import('../containers/admin/Institutions/InstitutionDetails'));
const AsyncInstitutionsTeamMembers = lazy(() => import('../containers/admin/InstitutionTeamMembers'));
const AsyncInstitutionsTeamMembersCreate = lazy(() =>
  import('../containers/admin/InstitutionTeamMembers/forms/CreateForm')
);

const AsyncProfile = lazy(() => import('../containers/shared/profile'));
const AsyncAdminAuditTrail = lazy(() => import('../containers/shared/admin/auditTrail'));
// Insights
const AsyncInsights = lazy(() => import('../containers/shared/insights/AllInsights'));
const AsyncManageInsights = lazy(() => import('../containers/admin/Insights'));
const AsyncInsightsDetails = lazy(() => import('../containers/admin/Insights/forms/Details'));
const AsyncInsightsEmbedFrame = lazy(() => import('../containers/shared/insights/InsightsEmbedReport'));

export const adminRoutes = [
  {
    breadcrumbs: [{ title: 'Admin', path: '/admin' }],
    exact: true,
    path: '/admin',
    component: AsyncLanding,
  },
  {
    breadcrumbs: [{ title: 'Admin', path: '/admin/insights' }],
    exact: true,
    path: '/admin/insights',
    component: AsyncInsights,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/admin' },
      { title: 'Insights', path: '/admin/insights' },
    ],
    exact: true,
    path: '/admin/insights/:insightType/:insightId',
    component: AsyncInsightsEmbedFrame,
  },
  {
    breadcrumbs: [{ title: 'Admin', path: '/admin/my-profile' }],
    exact: true,
    path: '/admin/my-profile',
    component: AsyncProfile,
  },
  {
    breadcrumbs: [
      { title: 'Admin', path: '/admin' },
      {
        title: 'Team Members',
        path: '/admin/team-members',
      },
    ],
    exact: true,
    path: '/admin/team-members',
    component: AsyncAdminTeamMembers,
  },

  // Create team member
  {
    breadcrumbs: [
      { title: 'Admin', path: '/admin' },
      { title: 'Team Members', path: '/admin/team-members/create-new' },
    ],
    exact: true,
    path: '/admin/team-members/create-new',
    component: AsyncAdminTeamMembersCreate,
  },

  // edit team member
  {
    breadcrumbs: [
      { title: 'Admin', path: '/admin' },
      { title: 'Team Members', path: '/admin/team-members/:teamMemberId' },
    ],
    exact: true,
    path: '/admin/team-members/:teamMemberId',
    component: AsyncAdminTeamMembersCreate,
  },

  // institutions
  {
    breadcrumbs: [
      { title: 'Admin', path: '/admin' },
      {
        title: 'Institutions',
        path: '/admin/institutions',
      },
    ],
    exact: true,
    path: '/admin/institutions',
    component: AsyncInstitutions,
  },

  // Create institution
  {
    breadcrumbs: [
      { title: 'Admin', path: '/admin' },
      { title: 'Institutions', path: '/admin/institutions' },
    ],
    exact: true,
    path: '/admin/institutions/create',
    component: AsyncInstitutionsCreate,
  },

  // edit institution
  {
    breadcrumbs: [
      { title: 'Admin', path: '/admin' },
      { title: 'Institutions', path: '/admin/institutions' },
    ],
    exact: true,
    path: '/admin/institutions/:institutionId',
    component: AsyncInstitutionsCreate,
  },

  // institution team members
  {
    breadcrumbs: [{ title: 'Admin', path: '/admin' }],
    exact: true,
    path: '/admin/institutions/:institutionId/team-members',
    component: AsyncInstitutionsTeamMembers,
  },

  // Create institution team member
  {
    breadcrumbs: [{ title: 'Admin', path: '/admin' }],
    exact: true,
    path: '/admin/institutions/:institutionId/team-members/create-new',
    component: AsyncInstitutionsTeamMembersCreate,
  },

  // edit institution team member
  {
    breadcrumbs: [{ title: 'Admin', path: '/admin' }],
    exact: true,
    path: '/admin/institutions/:institutionId/team-members/:teamMemberId',
    component: AsyncInstitutionsTeamMembersCreate,
  },

  // funders
  {
    breadcrumbs: [
      { title: 'Admin', path: '/admin' },
      {
        title: 'Funders',
        path: '/admin/funders',
      },
    ],
    exact: true,
    path: '/admin/funders',
    component: AsyncFunders,
  },

  // Create funder
  {
    breadcrumbs: [
      { title: 'Admin', path: '/admin' },
      { title: 'Funders', path: '/admin/funders/create-new' },
    ],
    exact: true,
    path: '/admin/funders/create-new',
    component: AsyncFundersCreate,
  },

  // edit funder
  {
    breadcrumbs: [
      { title: 'Admin', path: '/admin' },
      { title: 'Funders', path: '/admin/funders/:funderId' },
    ],
    exact: true,
    path: '/admin/funders/:funderId',
    component: AsyncFundersCreate,
  },

  // funder team members
  {
    breadcrumbs: [{ title: 'Admin', path: '/admin' }],
    exact: true,
    path: '/admin/funders/:funderId/team-members',
    component: AsyncFunderTeamMembers,
  },

  // Create funder team member
  {
    breadcrumbs: [{ title: 'Admin', path: '/admin' }],
    exact: true,
    path: '/admin/funders/:funderId/team-members/create-new',
    component: AsyncFunderTeamMembersCreate,
  },

  // edit funder team member
  {
    breadcrumbs: [{ title: 'Admin', path: '/admin' }],
    exact: true,
    path: '/admin/funders/:funderId/team-members/:teamMemberId',
    component: AsyncFunderTeamMembersCreate,
  },

  // service providers
  {
    breadcrumbs: [
      { title: 'Admin', path: '/admin' },
      {
        title: 'Service Providers',
        path: '/admin/service-providers',
      },
    ],
    exact: true,
    path: '/admin/service-providers',
    component: AsyncServiceProviders,
  },

  // Create service provider
  {
    breadcrumbs: [
      { title: 'Admin', path: '/admin' },
      { title: 'Service Providers', path: '/admin/service-providers/create-new' },
    ],
    exact: true,
    path: '/admin/service-providers/create-new',
    component: AsyncServiceProvidersCreate,
  },

  // edit service provider
  {
    breadcrumbs: [
      { title: 'Admin', path: '/admin' },
      { title: 'Service Providers', path: '/admin/service-providers/:serviceProviderId' },
    ],
    exact: true,
    path: '/admin/service-providers/:serviceProviderId',
    component: AsyncServiceProvidersCreate,
  },

  // funder team members
  {
    breadcrumbs: [{ title: 'Admin', path: '/admin' }],
    exact: true,
    path: '/admin/service-providers/:serviceProviderId/team-members',
    component: AsyncServiceProviderTeamMembers,
  },

  // Create funder team member
  {
    breadcrumbs: [{ title: 'Admin', path: '/admin' }],
    exact: true,
    path: '/admin/service-providers/:serviceProviderId/team-members/create-new',
    component: AsyncServiceProviderTeamMembersCreate,
  },

  // edit funder team member
  {
    breadcrumbs: [{ title: 'Admin', path: '/admin' }],
    exact: true,
    path: '/admin/service-providers/:serviceProviderId/team-members/:teamMemberId',
    component: AsyncServiceProviderTeamMembersCreate,
  },

  // programmes
  {
    breadcrumbs: [
      { title: 'Admin', path: '/admin' },
      {
        title: 'Programmes',
        path: '/admin/programmes',
      },
    ],
    exact: true,
    path: '/admin/programmes',
    component: AsyncProgrammes,
  },

  // Create programme
  {
    breadcrumbs: [
      { title: 'Admin', path: '/admin' },
      { title: 'Programmes', path: '/admin/programmes/create-new' },
    ],
    exact: true,
    path: '/admin/programmes/create-new',
    component: AsyncProgrammesCreate,
  },

  // edit programme
  {
    breadcrumbs: [
      { title: 'Admin', path: '/admin' },
      { title: 'Programmes', path: '/admin/programmes/:programmeId' },
    ],
    exact: true,
    path: '/admin/programmes/:programmeId',
    component: AsyncProgrammesCreate,
  },

  {
    breadcrumbs: [
      { title: 'Admin', path: '/admin' },
      {
        title: 'Interventions',
        path: '/admin/interventions',
      },
    ],
    exact: true,
    path: '/admin/interventions',
    component: NoContentPage,
  },
  {
    breadcrumbs: [
      { title: 'Admin', path: '/admin' },
      {
        title: 'Institutions',
        path: '/admin/institutions',
      },
    ],
    exact: true,
    path: '/admin/institutions',
    component: NoContentPage,
  },

  // admin templates
  {
    breadcrumbs: [
      { title: 'Admin', path: '/admin' },
      {
        title: 'Forms',
        path: '/admin/templates',
      },
    ],
    exact: true,
    path: '/admin/templates',
    component: AsyncAdminTemplates,
  },
  {
    breadcrumbs: [
      { title: 'Admin', path: '/admin' },
      { title: 'Forms', path: '/admin/templates' },
      { title: 'Create', path: '/admin/templates/create-new' },
    ],
    exact: true,
    path: '/admin/templates/create-new',
    component: AsyncAdminTemplateDetails,
  },
  {
    breadcrumbs: [
      { title: 'Admin', path: '/admin' },
      { title: 'Forms', path: '/admin/templates' },
    ],
    exact: true,
    path: '/admin/templates/:templateId',
    component: AsyncAdminTemplateDetails,
  },

  // admin declarations
  {
    breadcrumbs: [
      { title: 'Admin', path: '/admin' },
      {
        title: 'Declarations',
        path: '/admin/declarations',
      },
    ],
    exact: true,
    path: '/admin/declarations',
    component: AsyncDeclarations,
  },
  {
    breadcrumbs: [
      { title: 'Admin', path: '/admin' },
      { title: 'Declarations', path: '/admin/declarations' },
      { title: 'Create', path: '/admin/declarations/create-new' },
    ],
    exact: true,
    path: '/admin/declarations/create-new',
    component: AsyncDeclarationDetails,
  },
  {
    breadcrumbs: [
      { title: 'Admin', path: '/admin' },
      { title: 'Declarations', path: '/admin/declarations' },
    ],
    exact: true,
    path: '/admin/declarations/:declarationId',
    component: AsyncDeclarationDetails,
  },

  // admin audit trail
  {
    breadcrumbs: [
      { title: 'Admin', path: '/admin' },
      { title: 'Audit Trail', path: '/admin/auditTrail' },
    ],
    exact: true,
    path: '/admin/auditTrail',
    component: AsyncAdminAuditTrail,
  },

  //Manage Insights
  {
    breadcrumbs: [
      { title: 'Admin', path: '/admin' },
      {
        title: 'Insights',
        path: '/admin/manage/insights',
      },
    ],
    exact: true,
    path: '/admin/manage/insights',
    component: AsyncManageInsights,
  },
  // Create Insight
  {
    breadcrumbs: [
      { title: 'Admin', path: '/admin' },
      { title: 'Insight', path: '/admin/manage/insights' },
    ],
    exact: true,
    path: '/admin/manage/insights/create-new',
    component: AsyncInsightsDetails,
  },
  // Update Insight
  {
    breadcrumbs: [
      { title: 'Admin', path: '/admin' },
      { title: 'Insight', path: '/admin/manage/insights' },
    ],
    exact: true,
    path: '/admin/manage/insights/:insightId',
    component: AsyncInsightsDetails,
  },
  {
    breadcrumbs: [
      { title: 'Admin', path: '/admin' },
      {
        title: 'People',
        path: '/admin/manage/people',
      },
    ],
    exact: true,
    path: '/admin/manage/people',
    component: AsyncPeople,
  },

  {
    breadcrumbs: [
      { title: 'Admin', path: '/admin' },
      { title: 'People', path: '/admin/manage/people/create' },
    ],
    exact: true,
    path: '/admin/manage/people/create',
    component: AsyncPeopleDetails,
  },

  {
    breadcrumbs: [
      { title: 'Admin', path: '/admin' },
      { title: 'People', path: '/admin/manage/people/:personId' },
    ],
    exact: true,
    path: '/admin/manage/people/:personId',
    component: AsyncPeopleDetails,
  },

  {
    breadcrumbs: [
      { title: 'Admin', path: '/admin' },
      {
        title: 'Learner Attendance',
        path: '/admin/school-attendance-data',
      },
    ],
    exact: true,
    path: '/admin/school-attendance-data',
    component: AsyncAttendance,
  },
  {
    breadcrumbs: [
      { title: 'Admin', path: '/admin' },
      {
        title: 'Report Results',
        path: '/admin/school-subject-report',
      },
    ],
    exact: true,
    path: '/admin/school-subject-report',
    component: AsyncReport,
  },
  {
    breadcrumbs: [
      { title: 'Admin', path: '/admin' },
      {
        title: 'School Progression',
        path: '/admin/school-progression-data',
      },
    ],
    exact: true,
    path: '/admin/school-progression-data',
    component: AsyncProgression,
  },
  {
    breadcrumbs: [
      { title: 'Admin', path: '/admin' },
      {
        title: 'Exam/Test Results',
        path: '/admin/test-performance',
      },
    ],
    exact: true,
    path: '/admin/test-performance',
    component: AsyncTest,
  },

  {
    breadcrumbs: [
      { title: 'Admin', path: '/admin' },
      {
        title: 'School Enrolment',
        path: '/admin/school-enrolment-data',
      },
    ],
    exact: true,
    path: '/admin/school-enrolment-data',
    component: AsyncSchoolEnrolment,
  },

  {
    breadcrumbs: [
      { title: 'Admin', path: '/admin' },
      { title: 'Data Tools', path: '/admin/data-tools' },
    ],
    exact: true,
    path: '/admin/data-tools',
    component: AsyncDataTools,
  },

  {
    breadcrumbs: [
      { title: 'Admin', path: '/admin' },
      { title: 'Data Tools', path: '/admin/data-tools' },
    ],
    exact: true,
    path: '/admin/data-tools/:section',
    component: AsyncDataToolsSection,
  },

  {
    breadcrumbs: [
      { title: 'Admin', path: '/admin' },
      {
        title: 'School Promotion',
        path: '/admin/school-promotion-data',
      },
    ],
    exact: true,
    path: '/admin/school-promotion-data',
    component: AsyncSchoolPromotion,
  },

  {
    breadcrumbs: [
      { title: 'Admin', path: '/admin' },
      {
        title: 'Educator Attendance',
        path: '/admin/school-educators',
      },
    ],
    exact: true,
    path: '/admin/school-educators',
    component: AsyncSchoolEducator,
  },

  {
    breadcrumbs: [
      { title: 'Admin', path: '/admin' },
      {
        title: 'NSC Subject Results',
        path: '/admin/nsc-subjects',
      },
    ],
    exact: true,
    path: '/admin/nsc-subjects',
    component: AsyncNSCSubjects,
  },

  {
    breadcrumbs: [
      { title: 'Admin', path: '/admin' },
      {
        title: 'NSC Progression',
        path: '/admin/nsc-progression',
      },
    ],
    exact: true,
    path: '/admin/nsc-progression',
    component: AsyncNSCProgression,
  },
];
